import React from 'react';
import { Routes, Route } from "react-router-dom";
import Navbar from './Navbar';
import Home from './Home';
import About from './About';
import Services from './Services';
import Contact from './Contact';
import ScrollToTop from "./ScrollToTop";

function App() {
  const appStyle = {
    fontFamily: 'Arial, sans-serif',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  };
  const mainStyle = { flex: 1 };

  // Floating phone button style
  const phoneButtonStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    backgroundColor: '#FFD966', // yellow
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
    cursor: 'pointer',
    zIndex: 1000,
    transition: 'transform 0.2s ease',
    textDecoration: 'none',
  };
  const phoneIconStyle = {
    fontSize: '28px',
    color: '#0A2F44', // dark blue for contrast
  };

  return (
    <div style={appStyle}>
      <Navbar />
      <main style={mainStyle}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      {/* Floating phone button */}
      <a
        href="tel:9948803051"
        style={phoneButtonStyle}
        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        aria-label="Call us"
      >
        <span style={phoneIconStyle}>📞</span>
      </a>
    </div>
  );
}

export default App;